import { DataService } from './dataService'
const localOriginCharges = {

	///////////////////////////////////////// air-origin ////////////////////////////////////////////////

	addLocalOriginChargeAir: async (data) => {
		return DataService.post('/admin/add_local_origin_charge_air', data)
	},

	updateLocalOriginChargeStatusAir: async (data) => {
		return DataService.post('/admin/update_local_origin_charge_status_air', data)
	},

	updateLocalOriginChargeAir: async (data) => {
		return DataService.post('/admin/update_local_origin_charge_air', data)
	},

	getLocalOriginChargeAir: async (data) => {
		return DataService.get('/admin/get_local_origin_charge_air', data)
	},

	///////////////////////////////////////////// Local-origin //////////////////////////////////////////
	
	addLocalOriginChargeCourier: async (data) => {
		return DataService.post('/admin/add_local_origin_charge_courier', data)
	},

	updateLocalOriginChargeCourier: async (data) => {
		return DataService.post('/admin/update_local_origin_charge_courier' ,data)
	},

    updateLocalOriginChargeStatusCourier: async (data) => {
        return DataService.post('/admin/update_local_origin_charge_status_courier' ,data)
    },

    getLocalOriginChargeCourier: async (data) => {
		return DataService.get('/admin/get_local_origin_charge_courier', data)
	},

	//////////////////////////////////////////// Sea-origin /////////////////////////////////////////

	addLocalOriginChargeSea: async (data) => {
		return DataService.post('/admin/add_local_origin_charge_sea', data)
	},

	updateLocalOriginChargeSea: async (data) => {
		return DataService.post('/admin/update_local_origin_charge_sea', data)
	},

	updateLocalOriginChargeStatusSea: async (data) => {
		return DataService.post('/admin/update_local_origin_charge_status_sea', data)
	},

	getLocalOriginChargeSea: async (data) => {
		return DataService.get('/admin/get_local_origin_charge_sea', data)
	},
	
	////////////////////////////////////////////// Cross-border /////////////////////////////////////////
	
	addLocalOriginChargeCrossBorder: async (data) => {
		return DataService.post('/admin/add_local_origin_charge_cross_border', data)
	},

	updateLocalOriginChargeCrossBorder: async (data) => { 
		return DataService.post('/admin/update_local_origin_charge_cross_border', data)
	},

	updateStatusLocalOriginChargeCrossBorder: async (data) => {
		return DataService.post('/admin/update_local_origin_charge_cross_border', data)
	},

	getLocalOriginChargeCrossBorder: async (data) => {
		return DataService.get('/admin/get_local_origin_charge_cross_border', data)
	},

	///////////////////////////////////////// air-origin-consolidation ////////////////////////////////////////////////

	addLocalOriginConsolidationChargeAir: async (data) => {
		return DataService.post('/admin/add_origin_charge_air_consolidation', data)
	},

	updateLocalOriginConsolidationChargeAir: async (data) => {
		return DataService.put('/admin/update_origin_charge_air_consolidation', data)
	},

	getLocalOriginConsolidationChargeAir: async (data) => {
		return DataService.get('/admin/get_origin_charge_air_consolidation', data)
	},
	
	//////////////////////////////////////////// Sea-origin-destination /////////////////////////////////////////

	addLocalOriginConsolidationChargeSea: async (data) => {
		return DataService.post('/admin/add_origin_charge_sea_consolidation', data)
	},

	updateLocalOriginConsolidationChargeSea: async (data) => {
		return DataService.put('/admin/update_origin_charge_sea_consolidation', data)
	},

	getLocalOriginConsolidationChargeSea: async (data) => {
		return DataService.get('/admin/get_origin_charge_sea_consolidation', data)
	},
	
}

export default localOriginCharges